
import React from 'react';
import {sprintf} from "sprintf-js";

const Result = props => {
  const size = "1.4rem";
  if (props.state === "passed") {
    return (<i style={{fontSize: size, color: "green"}} className="fa fa-check-circle"></i>);
  }
  return (<i style={{fontSize: size, color: "red"}} className="fa fa-times-circle"></i>)
}

const Stopwatch = () => {
  return (<i className="fa fa-clock-o"></i>)
}

const CypressResults = props => {

  const container_style = {
    display: "flex",
  }

  return (
    <div style={container_style}>
      <div style={{paddingRight: "1rem"}}>
        <Result {...props} />
      </div>
      <div style={{ flex: "1"}}>
        { props.title }
      </div>
      <div>
        { sprintf("%f sec", props.duration / 1000) }
      </div>
      <div style={{paddingLeft: "1rem"}}>
        <Stopwatch/>
      </div>
    </div>
  )
}

export { CypressResults };
